/**
 * Offset from screen bottom for standalone view
 */
export const STANDALONE_BOTTOM_OFFSET_PX = 16;
